import { lazy } from 'react';

const assetRoutes = [
    {
        exact: true,
        path: '/assets',
        component: lazy(() => import('../views/myAssets'))
    },
    {
        exact: true,
        path: '/datumOrders',
        component: lazy(() => import('../views/myAssets/AllDatumOrders/OrdersForAllDatum'))
    },
    {
        exact: true,
        path: '/assetsLocation',
        component: lazy(() => import('../views/myAssets/MapViewForAsset'))
    },
    {
        exact: true,
        path: '/newassets',
        component: lazy(() => import('../views/myAssets/AssetDashbord'))
    },
    {
        exact: true,
        path: '/editAsset',
        component: lazy(() => import('../views/myAssets/EditAsset'))
    },
    {
        exact: true,
        path: '/emailSetting',
        component: lazy(() => import('../views/myAssets/EmailSetting/EmailSetting.js'))
    },
    {
        exact: true,
        path: '/allDatumOrders/:tab',
        component: lazy(() => import('../views/myAssets/DatumFlow/DatumOrders'))
    },
    {
        exact: true,
        path: '/allDatumOrders',
        component: lazy(() => import('../views/myAssets/DatumFlow/DatumOrders'))
    },
    {
        exact: true,
        path: '/Datums',
        component: lazy(() => import('../views/myAssets/DatumFlow/Datum.js'))
    },
    {
        exact: true,
        path: '/Datums/:tab',
        component: lazy(() => import('../views/myAssets/DatumFlow/Datum.js'))
    },
    {
        exact: true,
        path: '/DatumOrders',
        component: lazy(() => import('../views/myAssets/DatumFlow/Datum.js'))
    },
    {
        exact: true,
        path: '/despence',
        component: lazy(() => import('../views/myAssets/AssetPages'))
    },
    {
        exact: true,
        path: '/AssetData',
        component: lazy(() => import('../views/myAssets/NonDatumAsset'))
    },
    {
        exact: true,
        path: '/refill',
        component: lazy(() => import('../views/myAssets/Assetpage2'))
    },
    {
        exact: true,
        path: '/transactions',
        component: lazy(() => import('../views/myAssets/DatumReport/DatumRefill'))
    },
    {
        exact: true,
        path: '/newasset',
        component: lazy(() => import('../views/myAssets/AssetDashbord'))
    },
    {
        exact: true,
        path: '/datumOrder',
        component: lazy(() => import('../views/myAssets/NonDatumAsset/DatumOrder'))
    },
    {
        exact: true,
        path: '/Datum/:tab',
        component: lazy(() => import('../views/myAssets/DatumFlow/Datum'))
    },
    {
        exact: true,
        path: '/Datum',
        component: lazy(() => import('../views/myAssets/DatumFlow/Datum'))
    },
    {
        exact: true,
        path: '/analytics',
        component: lazy(() => import('../views/myAssets/SubAssetAnalytics/index'))
    },
    {
        exact: true,
        path: '/TestResult',
        component: lazy(() => import('../views/myAssets/FiveLitreJarTest/index'))
    },
    {
        exact: true,
        path: '/dipLog',
        component: lazy(() => import('../views/myAssets/NonDatumAsset/DipLogHistory.js'))
    },
    {
        exact: true,
        path: '/eLock',
        component: lazy(() => import('../views/E-Lock/E-LockFlow/ELockApproval.js'))
    }
];

export default assetRoutes;
